import { AxiosRequestConfig } from "axios";
import proxyInstance from "src/config/api/proxyInstance";

export const getMe = (config?: AxiosRequestConfig) =>
  proxyInstance.get("users/auth/user", config);
